<template>
  <standard-dialog
    v-model="model"
    :title="restaurant ? toLatin(restaurant.name) : $t('restaurant')"
    icon="mdi-store"
    max-width="700"
    hide-actions
  >
    <div v-if="restaurant" class="restaurant-details">
      <!-- Basic Info Card -->
      <v-card outlined class="mb-4">
        <v-card-text class="pa-4">
          <!-- Contact Information -->
          <div class="info-section">
            <div class="info-row d-flex align-center mb-2">
              <v-icon small color="orange" class="mr-3">mdi-map-marker</v-icon>
              <div>
                <div class="text-caption grey--text">{{ $t("address") }}</div>
                <div class="text-body-2">{{ toLatin(restaurant.address) }}</div>
              </div>
            </div>

            <div class="info-row d-flex align-center mb-2">
              <v-icon small color="orange" class="mr-3">mdi-city</v-icon>
              <div>
                <div class="text-caption grey--text">{{ $t("city") }}</div>
                <div class="text-body-2">
                  {{ restaurant.city ? toLatin(restaurant.city.name) : "-" }}
                </div>
              </div>
            </div>

            <div class="info-row d-flex align-center mb-2">
              <v-icon small color="orange" class="mr-3">mdi-phone</v-icon>
              <div>
                <div class="text-caption grey--text">{{ $t("phone") }}</div>
                <div class="text-body-2">{{ restaurant.phone || "-" }}</div>
              </div>
            </div>

            <div class="info-row d-flex align-center mb-2">
              <v-icon small color="orange" class="mr-3">mdi-email</v-icon>
              <div>
                <div class="text-caption grey--text">{{ $t("email") }}</div>
                <div class="text-body-2">{{ restaurant.email || "-" }}</div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";

export default {
  name: "RestaurantDetailsDialog",
  mixins: [hasModel],
  props: {
    restaurant: {
      type: Object,
      default: null,
    },
  },
  components: {
    StandardDialog,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    getUserTypeColor(type) {
      const colors = {
        admin: "orange",
        restaurant: "blue",
        report_guest: "green",
        delivery: "purple",
      };
      return colors[type] || "grey";
    },
  },
};
</script>

<style scoped>
.restaurant-details {
  max-height: 70vh;
}

.info-section {
  padding-left: 4px;
}

.info-row {
  min-height: 48px;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.user-item:last-child {
  padding-bottom: 0;
}

.delivery-info {
  padding: 0 8px;
}
</style>
